<template>
  <div>
    <!-- <el-row>
        <div class="model-header">
            <h2>Kết quả thi học viên : {{ modelData.user_txt }}</h2>
            <el-button @click="backModel" size="small" class="btn-back">Trờ về</el-button>
        </div>
    </el-row> -->
    <el-row>
      <!-- <div v-if="modelData.id">
          <test-result-index :user_id="modelData.user_id"></test-result-index>
      </div> -->
      <h2>Tạo mới phòng thi</h2>
      <div class="model-content">
        <el-col :span="24">
          <el-row :gutter="20">
            <el-col :span="24" v-if="modelData">
              <el-form label-position="top" :model="modelData" ref="createModel" label-width="160px">
                <el-row gutter="20">
                  <el-col :span="12">
                    <el-form-item prop="name" label="Tên phòng:" class="form-item" :rules="[
                      { required: true, message: 'Vui lòng nhập tên phòng' }
                    ]">
                      <el-input v-model="modelData.name" class="input-seach"></el-input>
                    </el-form-item>
                    <el-form-item prop="host_id" label="Giảng viên:" class="form-item">
                      <el-select filterable v-model="modelData.host_id" placeholder="Chọn giảng viên" :rules="[
                        { required: true, message: 'Vui lòng chọn giảng viên' }
                      ]">
                        <el-option v-for="item in teacher" :key="item.id" :label="item.name" :value="item.id">
                        </el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item prop="course_id" label="Đề thi:" class="form-item">
                      <el-select v-model="modelData.test_id" placeholder="Chọn đề thi" @change="changeTestId">
                        <el-option v-for="item in tests" :key="item.id" :label="item.name" :value="item.id">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item prop="time_start" label="Ngày bắt đầu:" class="form-item" :rules="[
                      { required: true, message: 'Vui lòng nhập ngày bắt đầu' }
                    ]">
                      <el-date-picker type="date" v-model="modelData.time_start" class="input-seach"></el-date-picker>
                    </el-form-item>
                    <el-form-item prop="start_at" label="Bắt đầu:" class="form-item" :rules="[
                      { required: true, message: 'Vui lòng nhập thời gian bắt đầu' }
                    ]">
                      <el-time-picker v-model="modelData.start_at" class="input-seach"
                        @change="setEndAtTestRoom"></el-time-picker>
                    </el-form-item>
                    <el-form-item prop="end_at" label="Kết thúc:" class="form-item" :rules="[
                      { required: true, message: 'Vui lòng nhập thơi gian kết thúc' }
                    ]">
                      <el-time-picker readonly v-model="modelData.end_at" class="input-seach"></el-time-picker>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row gutter="20">
                  <el-col :span="12">
                    <el-form-item prop="name" label="Danh sách học viên" class="form-item">
                      <el-select collapse-tags filterable v-model="modalDataUser" multiple placeholder="Chọn học viên"
                        collapse-tags-tooltip :max-collapse-tags="3">
                        <el-option v-for="item in users" :key="item.id" :label="item.name + ' - ' + item.email"
                          :value="item.id">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row gutter="20">
                  <el-col :span="24" style="text-align: right">
                    <el-button type="primary" @click="submitForm('createModel')" :disable="!canSubmit"
                      :loading="!canSubmit">Lưu</el-button>
                    <el-button @click="backModel" size="small" class="btn-back">Trờ về</el-button>
                  </el-col>
                </el-row>
              </el-form>
            </el-col>
          </el-row>
        </el-col>
      </div>
    </el-row>
  </div>
</template>

<script>
import axios from 'axios'
import { mapActions } from 'vuex'
import moment from 'moment'
import { head } from 'lodash'
export default {
  name: 'CourseShow',
  metaInfo() {
    return {
      title: 'Danh sách lớp học'
    }
  },
  data() {
    return {
      canSubmit: true,
      modelData: {
        name: '',
        host_id: '',
        test_id: '',
        price: '0',
        time_start: '',
        time_end: '',
        start_at: '',
        end_at: '',
        users: [],
      },
      users: [],
      modalDataUser: [],
      modalDataTurTors: [],
      teacher: [],
      courses: [],
      isIndeterminate: true,
      checkedDates: [],
      checkAll: false,
      maxTagCount: null,
      tests: []
    }
  },
  mounted() {
    this.configBreadcrumb()
    this.fetchModel()
    this.fetchUsers()
    this.fetchCourse()
    this.fetchUserInTestRoom()
  },
  methods: {
    changeTestId(id) {
      let testKit = this.tests.find(item => item.id == id)
      if (this.modelData.start_at) {
        const endAt = moment(this.modelData.start_at).add(testKit.time, 'minutes').format('YYYY-MM-DD HH:mm:ss')
        this.modelData.end_at = new Date(
          '2023 07 26 ' + moment(endAt).format('HH:mm:ss')
        )
      }
    },
    setEndAtTestRoom(e) {
      // get time in test kit
      const testKit = this.tests.find(item => item.id === this.modelData.test_id)
      if (!testKit) {
        this.$notify({
          title: 'Thông báo',
          message: 'Bạn chưa chọn bộ đề',
          type: 'warning'
        });
      } else {
        const endAt = moment(this.modelData.start_at).add(testKit.time, 'minutes').format('YYYY-MM-DD HH:mm:ss')
        this.modelData.end_at = new Date(
          '2023 07 26 ' + moment(endAt).format('HH:mm:ss')
        )
      }

    },
    // Lấy action từ Vuex
    ...mapActions(['setBreadcrumb']),
    // Cấu hình Breadcrumb
    configBreadcrumb() {
      let breadcrumb = [
        { name: 'home-index', text: 'Trang chủ' },
        { name: 'class-live-index', text: 'Danh sách lớp học' },
        { name: 'class-live-create', text: 'Tạo mới lớp học' }
      ]

      this.setBreadcrumb(breadcrumb)
    },
    fetchUserInTestRoom() {
      this.canSubmit = false
      axios.get('get-user-in-room/' + this.$route.params.id).then(response => {
        switch (response.code) {
          case 200:
            this.canSubmit = true
            this.modalDataUser = response.data.map(item => item.user.id)
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    // Nút back lại trang Index
    backModel() {
      this.$router.push({ name: 'class-live-index' })
    },
    // get users
    fetchUsers() {
      this.canSubmit = false
      axios.get('get-users').then(response => {
        switch (response.code) {
          case 200:
            this.canSubmit = true
            this.users = response.data.filter(item => item.user_type == 3)
            this.teacher = response.data.filter(item => item.user_type == 2)
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    fetchModel() {
      axios.get('get-test-room/' + this.$route.params.id).then(response => {
        switch (response.code) {
          case 200:
            this.canSubmit = true
            this.modelData = response.data
            this.modelData.start_at = new Date(
              '2023 07 26 ' + this.modelData.start_at
            )

            this.modelData.end_at = new Date(
              '2023 07 26 ' + this.modelData.end_at
            )
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    fetchCourse() {
      this.canSubmit = false
      axios.get('get-tests-kit').then(response => {
        switch (response.code) {
          case 200:
            this.canSubmit = true
            this.tests = response.data
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.storeModel()
        } else {
          this.$notify({
            title: 'Lỗi dữ liệu nhập',
            message: 'Vui lòng kiểm tra lại thông tin',
            type: 'warning'
          })
          return false
        }
      })
    },
    storeModel() {
      this.canSubmit = false
      this.modelData.start_at = moment(this.modelData.start_at).format('HH:mm:ss')
      this.modelData.end_at = moment(this.modelData.end_at).format('HH:mm:ss')
      this.modelData.time_start = moment(this.modelData.time_start).format('YYYY-MM-DD')
      this.modelData.time_end = moment(this.modelData.time_end).format('YYYY-MM-DD')
      const data = {
        name: this.modelData.name,
        host_id: this.modelData.host_id,
        test_id: this.modelData.test_id,
        time_start: this.modelData.time_start,
        time_end: this.modelData.time_start,
        start_at: this.modelData.start_at,
        end_at: this.modelData.end_at,
        users: this.modalDataUser
      }
      axios.put('update-test-room/' + this.$route.params.id, data).then(response => {
        this.canSubmit = true
        if (response.code == 200) {
          this.$notify({
            title: 'Thành công',
            message: 'Cập nhật lớp học thành công',
            type: 'success'
          })
          this.$router.push({ name: 'test-room-index' })
        } else {
          let er = response.errors
          let message = head(er[Object.keys(er)[0]])
          this.$notify({
            title: 'Có lỗi xảy ra',
            message: message,
            type: 'warning'
          })
          this.modelData.start_at = new Date(
            '2023 07 26 ' + this.modelData.start_at
          )

          this.modelData.end_at = new Date(
            '2023 07 26 ' + this.modelData.end_at
          )
        }
      }).catch(error => {
        this.canSubmit = true
        this.$notify({
          title: 'Có lỗi xảy ra',
          message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !',
          type: 'warning'
        })
        this.modelData.start_at = new Date(
          '2023 07 26 ' + this.modelData.start_at
        )

        this.modelData.end_at = new Date(
          '2023 07 26 ' + this.modelData.end_at
        )
      })
    },

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style type="text/css" scoped>
.model-content {
  padding-top: 15px;
}

.el-select,
el-date-editor,
el-time-picker,
el-input {
  width: 100% !important;
}

.el-date-editor,
el-time-picker {
  width: 100% !important;
  height: 0 !important;
  padding-top: 0;
}

.input-seach input {
  height: auto !important;
}
</style>

<style type="text/css"></style>



// WEBPACK FOOTER //
// src/components/test-rooms/Show.vue